import React, { useState, useEffect } from 'react';
import { IconButton, styled } from '@mui/material';
import EmailIcon from '@mui/icons-material/EmailOutlined';

// 1. Определяем ключевые кадры для CSS-анимации 'shake'
const shakeAnimation = `
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-8px); }
    20%, 40%, 60%, 80% { transform: translateX(8px); }
  }
`;

// 2. Стилизованный IconButton с возможностью применения анимации
const AnimatedWhiteCircleButton = styled(IconButton)(({ theme }) => ({
    borderRadius: '50%',
    width: 56,
    height: 56,
    backgroundColor: '#04448D',
    boxShadow: theme.shadows[3],
    color: '#F6D514',
    display: 'flex', // Убедимся, что flex для центрирования иконки
    justifyContent: 'center',
    alignItems: 'center',

    // Опциональные стили при наведении (без изменения размера)
    '&:hover': {
        backgroundColor: "#246AB9",
        boxShadow: theme.shadows[6],
    },
}));

function ContactButton() {
    const [shouldAnimate, setShouldAnimate] = useState(true);

    // 3. Используем useEffect для запуска и остановки анимации
    useEffect(() => {
        // Вставляем CSS-анимацию в head документа при монтировании
        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = shakeAnimation;
        document.head.appendChild(styleSheet);

        // Устанавливаем таймер для удаления класса анимации
        const timer = setTimeout(() => {
            setShouldAnimate(false); // Отключаем анимацию после некоторого времени
        }, 5000); // Анимация будет длиться 1 секунду (соответствует длительности в @keyframes)

        // Функция очистки: удаляем стили и таймер при размонтировании компонента
        return () => {
            clearTimeout(timer);
            document.head.removeChild(styleSheet);
        };
    }, []); // Пустой массив зависимостей гарантирует, что эффект запустится только один раз при монтировании

    const handleClick = () => {
        window.open("https://t.me/evPoint_kz", "_blank");
    };

    return (
        <>
            <AnimatedWhiteCircleButton
                aria-label="Связаться по почте"
                onClick={handleClick}
                className={shouldAnimate ? 'shake-button' : ''}
                sx={{
                    // Здесь применяем CSS-анимацию
                    '&.shake-button': {
                        animation: 'shake 0.82s cubic-bezier(.36,.07,.19,.97) both',
                        transform: 'translate3d(0, 0, 0)',
                        backfaceVisibility: 'hidden',
                        perspective: '1000px',
                    },
                }}
            >
                <EmailIcon />
            </AnimatedWhiteCircleButton>
        </>
    );
}

export default ContactButton;